<template>
  <Toolbar class="p-mb-4 p-mt-4 p-p-2">
    <template #start>
      <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Working Hours') }}</div>
    </template>

    <template #end>
      <div class="p-d-flex p-flex-wrap p-ai-center">
        <div class="p-p-1">
          <Button @click="saveSettings"
                 :disabled="!$store.getters.isAdminOrHigher || locationIsLoading || fetchInFlight"
                 :loading="locationIsLoading || fetchInFlight"
                 class="p-button-raised"
                 icon="ti-save"
                 :label="$t('Save')"/>
        </div>
      </div>
    </template>
  </Toolbar>

  <div class="p-grid">
    <div class="p-col-12">
      <fieldset class="p-fieldset">
        <HoursEditor ref="wh"
                     v-model="workingHours"
                     :submitted="submitted"/>
      </fieldset>
    </div>
  </div>
</template>

<script>
import httpClient from "@/services/http.services";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import formatMixins from "@/mixins/formatMixins";
import HoursEditor from "@/pages/locations/components/HoursEditor.vue";

export default {
  name: 'LocationWorkingHoursSettings',
  components: { HoursEditor },
  emits: ['update-items'],
  mixins: [showErrorsMixins, formatMixins],
  props: {
    locationData: { type: Object, default: null },
    locationIsLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      fetchInFlight: false,
      submitted: false,
      workingHours: null, // { Mo: [["09:00","18:00"]], ... }
    };
  },
  mounted() {
    this.applySettings();
  },
  watch: {
    locationData: {
      deep: true,
      handler() {
        this.applySettings();
        this.submitted = false;
      },
    },
  },
  methods: {
    applySettings() {
      const wh = this.locationData?.working_hours;
      this.workingHours = (wh && typeof wh === "object") ? wh : null;
    },

    async saveSettings() {
      this.submitted = true;

      const locationId = this.locationData?.id;

      if (!locationId || this.fetchInFlight) return false;

      if (this.$refs.wh && typeof this.$refs.wh.validate === "function") {
        if (!this.$refs.wh.validate()) return false;
      }

      this.fetchInFlight = true;

      const payload = {
        location_id: locationId, // обязательно
        working_hours: this.workingHours, // уже актуально через v-model
      };

      try {
        const { data, status } = await httpClient.post("location/settings-update", payload);

        if (status === 200 && data?.success) {
          this.$emit('update-items', locationId);
          this.$toast.add({
            severity: 'success',
            detail: this.$t('Data updated'),
            life: settings.toastLife,
          });

          // после успешного сохранения можно сбросить submitted
          this.submitted = false;
          return true;
        }

        this.showUnknownError();
        return false;
      } catch (err) {
        this.showError(err);
        return false;
      } finally {
        this.fetchInFlight = false;
        this.submitted = false
      }
    },
  },
};
</script>
<style scoped lang="scss">
.settings-input {
  width: 100%;
  max-width: 280px;
  min-width: 0;
  box-sizing: border-box;
}

.settings-input :deep(.p-inputnumber) {
  width: 100%;
  max-width: 280px;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
}

.settings-input :deep(.p-inputnumber-input),
.settings-input :deep(input.p-inputtext) {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.settings-input :deep(.p-inputnumber-button-group) {
  flex: 0 0 auto;
}

.p-col-12,
.p-sm-12,
.p-md-4,
.p-lg-4,
.p-fieldset {
  min-width: 0;
}
</style>